export const sourceCatalogueDescription = {
    
        'source_name': 'The name of the source (JHHMMSS.ss+DDMMSS.s) based on its right ascension and declination (J2000).',
   
    
        'pointing_name': 'The MALS pointing ID (JHHMMSS.ss±DDMMSS.s) based on the position (J2000) of the central source in NVSS or SUMSS.',
   
    
        'obs_dates_u': 'The date and time of the start of UHF-band observing block(s).',
   
    
        'obs_dates_l': 'The date and time of the start of L-band observing block(s).',
   
    
        'obs_band': 'The observing band: L = L-band and U = UHF-band.',
   
    
        'pbeam_version': 'The primary beam model (KATBEAM or HOLOBEAM) version used for the primary beam correction.',
   
    
        'fluxcal': 'The list of calibrator(s) used for flux density and bandpass calibration of the dataset.',
   
    
        'fluxscale': 'The flux density scales used for the flux density calibrators.',
   
    
        'spw_id': 'This defines whether the continuum image is from a SPW-based or a wideband processing. The possible values are LWB-WP, LWB-AWP, UWB-WP, UWB-AWP, LSPW i and USPW i; here i goes from 0 to 14, and WB and AWP identify the wideband imaging algorithm used (Bhatnagar et al. 2013).',
   
    
        'ref_freq': 'The reference frequency (MHz) of the continuum image.',
   
    
        'maj_restoring_beam': 'The major axis (arcsec) of the restoring beam.',
   
    
        'min_restoring_beam': 'The minor axis (arcsec) of the restoring beam.',
   
    
        'pa_restoring_beam': 'The position angle (degrees) of the restoring beam.',
   
    
        'dist_pointing': 'The distance of the source (arcmin) from the pointing center.',
   
    
        'dist_nn': 'The distance of the source (arcmin) from the nearest neighbour in the field.',
   
    
        's_code': 'The PyBDSF code defining the source structure. S = a single source in the island, fitted with a single Gaussian component. C = a source with other neighbors within the island, fitted with a single Gaussian component. M = A source fitted with multiple Gaussian components.',
   
    
        'ra_mean': 'The right ascension (J2000) of the mean intensity weighted position of all pixels above the island threshold, measured if source is fitted with multiple Gaussians.',
   
    
        'ra_mean_error': 'The 1σ error on RA mean.',
   
    
        'dec_mean': 'The declination (J2000) of the mean intensity weighted position of all pixels above the island threshold, measured if source is fitted with multiple Gaussians.',
   
    
        'dec_mean_error': 'The 1σ error on DEC mean.',
   
    
        'ra_max': 'The right ascension (J2000) of the pixel corresponding to maximum flux density.',
   
    
        'ra_max_error': 'The 1σ error on RA max.',
   
    
        'dec_max': 'The declination (J2000) of the pixel corresponding to maximum flux density.',
   
    
        'dec_max_error': 'The 1σ error on DEC max.',
   
    
        'total_flux': 'The total integrated flux density (mJy) of the source based on Gaussian component fits; i.e., corrected for primary beam and wideband effects.',
   
    
        'total_flux_error': 'The 1σ error on Total flux.',
   
    
        'total_flux_e_sys': 'The systematic error to be taken into account to obtain the total error on Total flux.',
   
    
        'total_flux_measured': 'The placeholder for an intermediate flux density measurement. The details will be provided in corresponding data release notes.',
   
    
        'total_flux_measured_e': 'The 1σ error on Total flux measured',
   
    
        'isl_total_flux': 'The total integrated flux density (mJy) of the island in which the source is located.',
   
    
        'isl_total_flux_e': 'The 1σ error on Isl Total flux.',
   
    
        'isl_rms': 'The average background RMS noise (mJy beam⁻¹) of the island in which the source is located.',
   
    
        'isl_mean': 'The average background mean value (mJy beam⁻¹) of the island in which the source is located.',
   
    
        'reside_isl_rms': 'The average residual background RMS noise (mJy beam⁻¹) of the island in which the source is located.',
   
    
        'reside_isl_mean': 'Average residual background mean value (mJy beam⁻¹) of the island in which the source is located.',
   
    
        'flux_correction': 'The factor to be multiplied to Total flux and corresponding errors to account for any residual flux density calibration, primary beam and wideband corrections.',
   
    
        'spectral_index': 'The spectral index and curvature of the source determined from the wideband MTMFS image. For an extended source, a mean value for the pixels above some threshold in the island is reported.',
   
    
        'spectral_index_error': 'The 1σ error on Spectral index.',
   
    
        'spectral_index_measured': 'The placeholder for an intermediate spectral index measurement. The details are included in the corresponding data release notes.',
   
    
        'spectral_index_measured_error': 'The 1σ error on Spectral index measured',
   
    
        'spectral_index_spwused': 'The spectral windows used for determining spectral index and curvature using the narrowband MFS images. For example,[’L:1 4;7’, ’U:3 8;12’] implies Total flux from spectral windows 1 to 4 and 7 for L-band, and 3 to 8 and 12 for UHF-band are used',
   
    
        'spectral_index_spwfit': 'The spectral index and curvature of the source based on Total flux from narrowband images',
   
    
        'spectral_index_spwfit_e': 'The 1σ error on Spectral index spwfit.',
   
    
        'spectral_index_mals_lit': 'The spectral index and curvature based on Total flux from narrowband images from MALS and measurements from literature.',
   
    
        'spectral_index_mals_lit_e': 'The 1sigma error on Spectral index MALS Lit.',
   
    
        'spectral_index_lit': 'The list of external surveys (e.g., VLASS, TGSS) used.',
   
    
        'spectral_index_correction': 'The offset to be added to Spectral index and corresponding errors to account for any residual flux density calibration, primary beam and wideband corrections.',
   
    
        'real_source': 'This is a boolean (True or False or None) indicating whether a source is a real astrophysical source or an artifact.',
   
    
        'resolved': 'This is a boolean (True or False or None) indicating whether a source is unresolved.',
   
    
        'source_linked': 'This is a list of Source name i.e., other MALS sources to which the source may be linked to. This accounts for the linkages missed by grouping mechanism of PyBDSF',
   
    
        'n_gaus': 'The number of Gaussian components fitted to the source.',
   
    
        'ra': 'The right ascension (J2000) of maximum intensity of the Gaussian component.',
   
    
        'ra_e': 'The 1σ error on RA.',
   
    
        'dec': 'The declination (J2000) of maximum intensity of the Gaussian component.',
   
    
        'dec_e': 'The 1σ error on DEC E',
   
    
        'peak_flux': 'The measured peak flux density (mJy beam⁻¹) of the Gaussian component (using PyBDSF).',
   
    
        'peak_flux_e': 'The 1σ error on Peak flux.',
   
    
        'maj': 'The FWHM (arcsec) of the major axis of the Gaussian component.',
   
    
        'maj_e': 'The 1σ error on Maj.',
   
    
        'min': 'The FWHM (arcsec) of the minor axis of the Gaussian component.',
   
    
        'min_e': 'The 1σ error on Min.',
   
    
        'pa': 'The position angle (degrees) of the major axis of the Gaussian component.',
   
    
        'pa_e': 'The 1σ error on PA.',
   
    
        'dc_maj': 'The FWHM (arcsec) of the deconvolved major axis of the Gaussian component.',
   
    
        'dc_maj_e': 'The 1σ error on DC Maj.',
   
    
        'dc_min': 'The FWHM (arcsec) of the deconvolved minor axis of the Gaussian component.',
   
    
        'dc_min_e': 'The 1σ error on DC Min.',
   
    
        'dc_pa': 'The position angle (degrees) of the deconvolved major axis of the Gaussian component.',
   
    
        'dc_pa_e': 'The 1σ error on DC PA.'
    

}

export const dataPrecisions = {   
  'ref_freq': 2,
  'maj_restoring_beam': 1,
  'min_restoring_beam': 1,
  'pa_restoring_beam': 1,
  'sigma_1':1,
  'sigma_2':1,
  'sigma_20':1,
  'distance_pointing': 1,
  'distance_nn': 1,
  'maj':6,
  'maj_e':6,
  'min':6,
  'min_e':6,
  'pa':1,
  'pa_e':1,
  'dc_maj':6,
  'dc_maj_e':6,
  'dc_min':6,
  'dc_min_e':6,
  'dc_pa':1,
  'dc_pa_e':1,
  'ra_mean': 9,
  'ra_mean_e': 9,
  'dec_mean': 9,
  'dec_mean_e': 9,
  'ra_max': 9,
  'ra_max_e': 9,
  'dec_max': 9,
  'dec_max_e': 9,
  'total_flux': 2,
  'total_flux_e': 2,
  'total_flux_e_fit':2,
  'total_flux_e_sys': 2,
  'total_flux_measured': 2,
  'total_flux_measured_e': 2,
  'peak_flux':2,
  'peak_flux_e':2,
  'isl_total_flux': 2,
  'isl_total_flux_e': 2,
  'isl_rms': 2,
  'isl_mean': 2,
  'resid_isl_rms': 2,
  'resid_isl_mean': 3,
  'flux_correction': 3,
  'g_ra':9,
  'g_ra_e':9,
  'g_dec':9,
  'g_dec_e':9,
  'g_peak_flux':2,
  'g_peak_flux_e':2,
  'g_maj':6,
  'g_maj_e':6,
  'g_min':6,
  'g_min_e':6,
  'g_pa':1,
  'g_pa_e':1,
  'g_dc_maj':6,
  'g_dc_maj_e':6,
  'g_dc_min':6,
  'g_dc_min_e':6,
  'g_dc_pa':1,
  'g_dc_pa_e':1,
  'spec_cnt_peakflux_sm': 6,
  'spec_contbmaj_sm': 1,
  'spec_contbmin_sm': 1,
  'spec_contposa_sm': 1,
  'spec_distance_pointing': 2,
  'spec_scale_factor': 3

};

export const arrayDataPrecisions = {
  'spectral_index': 3,
  'spectral_index_spwfit': 3,
  'spectral_index_spwfit_e': 3,
  'spectral_index_mals_lit': 3,
  'spectral_index_mals_lit_e': 3
};

export const conditionalDataPrecision = {
  'maxsep_gauss': {
    'precision': 1,
    'predicate': (x) => x != -1
  }
}



